export default class Project {
    constructor () {
        this.id = null
        this.client_id = null
        this.project_owner_id = null
        this.project_type_id = null
        this.title = ""
        this.start_date = ""
        this.end_date = ""
        this.stages = [1,2,3]
    }
}